import React, { useContext } from 'react';
import { FilterContext } from '../GlobalFilterProvider/GlobalFilterProvider.esm.js';

/**
 * This provides the context to your filters
 *
 * ### Import Guide
 *
 * ```jsx
 * import { FilterProvider, GlobalFilterProvider } from "@panwds/react-filters";
 * ```
 *
 * GlobalFilterProvider should already be set in the Root component of your project,
 * but when writing tests, you'll need to wrap your component with GlobalFilterProvider.
 */
const FilterProvider = (props) => {
    const { children, name } = props;
    const context = useContext(FilterContext);
    return (React.createElement(FilterContext.Provider, { value: {
            ...context,
            name: name,
        } }, children));
};

export { FilterProvider };
//# sourceMappingURL=FilterProvider.esm.js.map
